import React, { useContext, useEffect, useRef, useState } from "react";
import { loginCSS } from "./Login.css";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { get, set, useForm } from "react-hook-form";
import { fetchLogin, fetchUser, validateTkn } from "../../Components/Functions/functions";
import { url } from "../../env";
import { useNavigate } from "react-router-dom";
import { Header, Loader } from "../../Components";
import { AuthContext } from "../../Context/AuthContext";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Card } from "primereact/card";
import { peicarLogoSVG } from '../../Assets/Images';
import { Toast } from "primereact/toast";
import axios from "axios";
import ModalGral from "./ModalGralLogin";

function Login({ isRegistered, setStep, secret, id, setState }) {
  const { authInfo, setUser } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const toast = useRef(null);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    getValues,
  } = useForm({
    defaultValues: {
      email: null,
      password: null,
    },
  });

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {

    const fetchUserData = async () => {
      if (authInfo?.token) {
        if (isRegistered != null && !isRegistered?.valid && secret) {
          toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: 'Token inválido, Inicia sesión',
            life: 3000,
          });
          localStorage.removeItem("token");
          // si ya trae datosn la vcariable no hacer la peticion
          if (!isRegistered?.data) {
            try {
              const result = await fetchUser(url, { secret, id });
              if (result) {
                setValue("email", result.email);
                setValue("name", result.name);
                setState((prev) => ({ ...prev, fetchUserData: result }));
              }
            } catch (error) {
              console.error("Error en fetchUser:", error);
              // Maneja el error aquí si es necesario
            }
          }

          return;
        }

        // if (authInfo?.user?.type_user !== 1 && setStep) {
        if (authInfo?.user?.type_user !== 1 && (setStep || secret)) {
          setStep(3);
          return;
        }

        const t = String(authInfo?.user?.type_user);
        if (t === '1') {
          navigate("/admin");
          return;
        }
        if (t === '3') {
          navigate("/admin-trim");
          return;
        }
        if (t === '2' || t === '4') {
          navigate("/vendedor");
          return;
        }
      }

      if (authInfo?.user?.email) {
        setValue("email", authInfo?.user?.email);
      }
    };

    fetchUserData();
  }, [authInfo, setStep, navigate, setValue]);

  useEffect(() => {
    if (isRegistered?.data?.email) {
      setValue("email", isRegistered.data.email);
    }
  }, [isRegistered?.data, setValue]);

  const submit = async (data) => {
    setLoading(true);
    setMessage("");
    const newDta = { ...data, secret, id };
    try {
      const result = await fetchLogin(url, newDta);
      // console.log(secret  , id)
      if (result.status === 200) {
        const t = String(result?.type_user);

        // ── Usuarios internos (Pei / Trim) ──────────────────────────────
        if (t === '1' || t === '2' || t === '3' || t === '4') {
          localStorage.setItem("token", result.token);
          setUser(result);

          if (t === '1') {
            navigate("/admin");
            return;
          }
          if (t === '3') {
            navigate("/admin-trim");
            return;
          }
          if (t === '2' || t === '4') {
            navigate("/vendedor");
            return;
          }
        }

        // ── Cliente (type_user null) ────────────────────────────────────
        // Solo redirige a /cotizar si tiene secret + budget (vino de cotización)
        if (!setStep && result?.secret && result?.idBudget) {
          localStorage.setItem("token", result.token);
          setUser(result);
          navigate("/cotizar/secret/" + result.secret + "?id=" + result.idBudget);
          setLoading(false);
          return;
        }

        setUser(result);
        localStorage.setItem("token", result.token);
        if (setStep) {
          setStep(3);
          return;
        }
        // Cliente sin budget asociado → su dashboard
        navigate("/mi-dashboard");
      } else {
        setMessage(result.includes("SQLSTATE") ? "Intente de nuevo más tarde" : result);
      }
    } catch (error) {
      // debugger
      console.error("Error en fetchLogin:", error);
      setMessage("Error en el login. Intente de nuevo más tarde.");
    } finally {
      setLoading(false);
    }
  };

  const handleOnChange = () => {
    setMessage("");
  };

  const handleTogglePassword = () => {
    setShowPassword(prev => !prev);
  };

  const header = (
    <div style={{ padding: "4em" }}>
      <img alt="Card" src={peicarLogoSVG} />
    </div>
  );

  const footer = (
    <>
      <div className="containerBtn">
        <div className="col-12 p-2 ButtonContainer">
          <Button
            type="submit"
            label="Iniciar sesión"
            className="w-full Green Button py-3"
          />
        </div>
      </div>
      <div className="col-12 flex justify-content-center pt-6">
        <div
          className="shadowCard"
          style={{ height: "2rem", width: "80%" }}
        />
      </div>
    </>
  );



  const [showModal, setShowModal] = useState(false);

  return (
    <div css={loginCSS()}>
      {showModal && <ModalGral setShowModal={setShowModal} showModal={showModal} toast={toast} email={getValues("email")} setLoading={setLoading} />}
      {(loading || authInfo.loading) && <Loader />}
      {!authInfo.loading && (
        <>
          {!setStep && <Header />}
          <div className={`card flex justify-content-center ${setStep ? "pt-6" : ""}`}>
            <form
              onSubmit={handleSubmit(submit)}
              className="grid"
            >
              <Card title="Inicia sesión" style={{ background: "transparent" }} subTitle="Ingresa correo y contraseña" footer={footer} header={header} className="md:w-25rem shadow-none">

                <div className="col-12 p-2">
                  <InputText
                    maxLength={40}
                    {...register("email", {
                      required: true,
                      pattern: /^(([^<>()\[\]\\.,;:\s@”]+(\.[^<>()\[\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z\s]{2,}))$/,
                      maxLength: 40,
                    })}
                    autoComplete="email"
                    onChange={handleOnChange}
                    placeholder="Correo electrónico"
                    className={`EmailInput w-full TextInput ${errors.email ? "p-invalid" : ""}`}
                  />
                </div>
                <div className="col-12 p-2">
                  <IconField iconPosition="right">
                    <div className="p-inputgroup flex-1">
                      <InputText
                        {...register("password", {
                          required: true,
                          minLength: 8,
                        })}
                        onChange={handleOnChange}
                        autoComplete="password"
                        type={showPassword ? "text" : "password"}
                        placeholder="Contraseña"
                        className={`w-full TextInput ${errors.password ? "p-invalid" : ""}`}
                        append={
                          <button type="button" onClick={handleTogglePassword}>
                            {showPassword ? (
                              <i className="pi pi-eye" style={{ fontSize: '2rem' }} />
                            ) : (
                              <i className="pi pi-eye-slash" style={{ fontSize: '2rem' }} />
                            )}
                          </button>
                        }
                      />
                    </div>
                    <InputIcon
                      onClick={handleTogglePassword}
                      style={{
                        zIndex: "100",
                        marginBottom: "1em",
                        top: "50%",
                        right: "1em",
                        transform: "translateY(-50%)", // Para centrar verticalmente
                        position: "absolute", // Asegúrate de que esté en posición absoluta
                      }}
                      className={showPassword ? "pi pi-eye-slash eyePassMobile" : "pi pi-eye eyePassMobile"}
                    />

                  </IconField>
                </div>

                <div className="col-12 p-2 pointer"
                  style={{
                    textAlign: "center",
                    color: "var(--text-color)",
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    cursor: "pointer",
                    textDecoration: "underline"
                  }}
                  onClick={() => setShowModal(true)}
                >
                  <span className="ForgotPassword">¿Olvidaste tu contraseña?</span>
                </div>


                <div className="Container">
                  {(message || errors.email || errors.password) && (
                    <div className="ErrorMessage">
                      {message && (
                        <span className="ErrorText">
                          {message}
                          <br />
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </Card>
            </form>
          </div>
          <Toast ref={toast} />
        </>
      )}
    </div>
  );
}

export { Login };
